<template>
    <div id="wrapper">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.report.trucker.indication.uses.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            {{$t('string.msg.connect.truck.register.trucker')}}
                                        </label>
                                        <multiselect v-model="trucker" :options="truckers" @input="selectItem(trucker)" 
                                            :close-on-select="true" track-by="_id" :custom-label="customLabelTrucker" :searchable="true"
                                            placeholder="Selecione" > 
                                        </multiselect>  
                                    </div>
                                </div>
                                <div class="form-row" v-if="items && items.length > 0">
                                    <div class="form-group col-md-4" v-if="items && items.length > 0">
                                        <h4>{{items[0].indicationcoderef.code}}</h4>
                                    </div>
                                     <div class="form-group col-md-4" >
                                        <h4>{{$t('str.total')}}</h4>
                                        <h4 class="ml-1">{{items.length}}</h4>
                                    </div>
                                    <div class="form-group col-md-4" >
                                        <download-excel
                                            class = "btn btn-primary"
                                            :fetch = "fetchData"
                                            :fields = "json_fields"
                                            type = "csv"
                                            :name = "nameCsv">
                                            Download CSV
                                        </download-excel>
                                    </div>
                                </div>
                               
                                <div class="table-responsive">
                                    <table class="table table-centered table-hover mb-0" id="datatable">
                                        <thead>
                                            <tr>
                                                <th class="border-top-0" style="width:50%">{{$t('string.msg.trucker.table.header.name')}}</th>
                                                <th class="border-top-0" style="width:50%">{{$t('string.msg.trucker.table.header.primaryPhone')}}</th>
                                                <th class="border-top-0" style="width:50%">{{$t('string.msg.trucker.table.header.date')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                                            <tr v-if="item && item.systemUser && item.systemUser.status == 'ACTIVE'">
                                                <td>
                                                    <span v-if="item.systemUser.firstName">
                                                        {{camelize(item.systemUser.firstName) + ' '}}
                                                    </span>
                                                     <span v-if="item.systemUser.lastName">
                                                        {{camelize(item.systemUser.lastName)}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.systemUser.primaryPhone">
                                                        {{camelize(item.systemUser.primaryPhone)}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.date">
                                                        {{new Date(item.date).toLocaleString()}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Controller from './CrtListIndication';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'ListIndication',
  props: ["valuekey"],
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        truckers: [],
        trucker: null,
        json_fields: {
            'Nome': 'systemUser.firstName',
            'Sobrenome': 'systemUser.lastName',
            'Telefone': 'systemUser.primaryPhone',
            'Data': 'date'
        },
        json_data: [
            {
                systemUser: {
                    firstName: null,   
                    lastName: null,        
                    primaryPhone: null
                },
                date: null
            }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
    }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    
  },
  mounted(){
    }
  }

</script>

<style>
.multiselect__option--highlight {
    background: #343B4A;
    outline: none;
    color: #fff;
}
.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #343B4A;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #343B4A;
}
</style>
